import React from 'react';
import clsx from "clsx";
import { connect } from 'react-redux';
import {Link, withRouter} from "react-router-dom";

import withStyles from '@material-ui/core/styles/withStyles';
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

import styles from './styles';
import {
  buildCurrentCustomerDashboardPath,
  buildCurrentCustomerDashboardVirtualPath,
  buildCurrentCustomerDocumentsPath,
  buildCurrentCustomerOtherAssetsListPath,
  buildCurrentCustomerOtherAssetsPath,
  ROUTES
} from "../../../../routes";
import {UserUtils} from "../../../../utils/utils";
import useOnClickOutside from "../../../../utils/useOnClickOutside";
import {customerLogout} from "../../../../containers/Authentication/Auth/utils";

const SideMenu = props => {
  const {
    classes,
    sideMenu,
    auth,
    guide,
    location: {pathname},
  } = props;

  const node = React.useRef();
  const [opened, setOpened] = React.useState(false);

  React.useEffect(() => {
    if (sideMenu.opened !== opened) {
      setOpened(sideMenu.opened)
    }
  }, [sideMenu])

  useOnClickOutside(node, () => {
    if (guide.open || guide.active) {
      return ;
    }
    if (opened) {
      setOpened(false);
    }
  });

  const handleSwitchMenuState = (event) => {
    setOpened(!opened);
  };

  const handleCustomerLogoutClick = () => {
    handleSwitchMenuState();
    customerLogout();
  };

  const activeClass = (path) => {
    return pathname.includes(path) ? classes.active : '';
  };

  return (
    <div className={clsx(classes.container, opened && classes.opened)} ref={node}>
      <div className={classes.button} onClick={handleSwitchMenuState}>
        <span className={classes.buttonLabel}>MENU</span> {opened ? <CloseIcon /> : <MenuIcon />}
      </div>

      {opened && (
        <div className={classes.sideMenuItems}>
          {UserUtils.isCustomer(auth) && (
            <>
              <div className={classes.section} id="portfolio-dashboard-tour-element-side-menu">
                <Link
                  to={buildCurrentCustomerDashboardPath()}
                  onClick={handleSwitchMenuState}
                  className={clsx(classes.item, activeClass(buildCurrentCustomerDashboardPath()))}
                >
                  {ROUTES.CUSTOMER.DASHBOARD.name}
                </Link>
              </div>

              {UserUtils.hasVirtualPortfolioAccess(auth) && <div
                id="virtual-portfolio-dashboard-tour-element-side-menu">
                  <Link
                    to={buildCurrentCustomerDashboardVirtualPath(auth.user.customer_id)}
                    onClick={handleSwitchMenuState}
                    className={clsx(classes.item, activeClass(buildCurrentCustomerDashboardVirtualPath(auth.user.customer_id)))}
                  >
                    {ROUTES.CUSTOMER.DASHBOARD_VIRTUAL.name}
                  </Link>
              </div>}

              <div className={classes.section} id="assets-tour-element-side-menu">
                <Link
                  to={buildCurrentCustomerOtherAssetsListPath()}
                  onClick={handleSwitchMenuState}
                  className={clsx(classes.item, activeClass(buildCurrentCustomerOtherAssetsPath()))}
                >
                  {ROUTES.CUSTOMER.OTHER_ASSETS_LIST.name}
                </Link>
              </div>
              <div className={classes.section} id="documents-tour-element-side-menu">
                <Link
                  to={buildCurrentCustomerDocumentsPath()}
                  onClick={handleSwitchMenuState}
                  className={clsx(classes.item, activeClass(buildCurrentCustomerDocumentsPath()))}
                >
                  {ROUTES.CUSTOMER.DOCUMENTS.name}
                </Link>
              </div>
              <div className={clsx(classes.section, classes.logout)} id="logout-button-tour-element-side-menu">
                <a
                  className={clsx(classes.item, classes.sectionHeader, classes.actionHeader)}
                  href={null}
                  onClick={handleCustomerLogoutClick}
                >
                  <i className={clsx(classes.itemIcon, 'fa fa-sign-out text-muted-opacity')} />
                  <span>Abmelden</span>
                </a>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (state) => ({
  auth: state.get('auth').toJS(),
  sideMenu: state.get('sideMenu').toJS(),
  guide: state.get('guide').toJS()
});

export default withStyles(styles)(connect(mapStateToProps)(withRouter(SideMenu)));